// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__hNUE_","pulse":"styles_pulse__xHP5_","jump":"styles_jump__aVe0G","wiggle":"styles_wiggle__UO27g"};